export const XS = 'xs'
export const SMALL = 'sm'
export const MEDIUM = 'md'
export const LARGE = 'lg'
export const XL = 'xl'
